module.exports = __webpack_public_path__ + "static/img/gzmt.b96c5eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzmt.jpg
// module id = O9Ep
// module chunks = 73